module.exports = __webpack_public_path__ + "img/tt-7.1778a1c5.png";